import React, { useState } from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from './ui/dropdown-menu';
import { Button } from './ui/button';
import { User, LogOut, Crown, Star } from 'lucide-react';
import { toast } from 'sonner';

export default function ProfileDropdown({ currentUser, onLogout, onViewAccount }) {
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    onLogout();
    setOpen(false);
    toast.success('✅ Logged out successfully');
  };

  if (!currentUser) return null;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white font-semibold">
            {currentUser.name.charAt(0).toUpperCase()}
          </div>
          <span className="hidden lg:inline">{currentUser.name}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{currentUser.name}</p>
            <p className="text-xs leading-none text-muted-foreground">{currentUser.email}</p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        {/* Account Status */}
        <div className="px-2 py-1.5">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Account Type:</span>
            {currentUser.is_pro ? (
              <div className="flex items-center gap-1 text-gold">
                <Crown className="w-4 h-4" />
                <span className="text-sm font-semibold">Pro</span>
              </div>
            ) : (
              <div className="flex items-center gap-1 text-primary">
                <Star className="w-4 h-4" />
                <span className="text-sm font-semibold">Free</span>
              </div>
            )}
          </div>
          {!currentUser.is_pro && (
            <div className="mt-1 text-xs text-muted-foreground">
              Prompts: {currentUser.prompts_used || 0}/10
            </div>
          )}
        </div>
        
        <DropdownMenuSeparator />
        
        {/* Profile Menu Items */}
        <DropdownMenuItem 
          onClick={() => {
            onViewAccount();
            setOpen(false);
          }}
          className="cursor-pointer"
        >
          <User className="mr-2 h-4 w-4" />
          <span>My Account</span>
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        {/* Logout */}
        <DropdownMenuItem 
          onClick={handleLogout} 
          className="cursor-pointer text-destructive focus:text-destructive"
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
